import React from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";

import { FullWidthWrapper } from "../../../Components/Wrappers";
import { ContentAnnouncement } from "../../../../components/molecules/contentAnnouncement";
import { ReactComponent as ClipsEmpty } from "../../../../MVVM/Assets/Placeholders/clips-empty.svg";
import { EClipsViews } from "../../../@types";
import { Button } from "../../../Components/Button";
import { analytics } from "MVVM/Analytics";
function EmptyContainer({ children }) {
  return (
    <EmptyContent display="box" py={[3]}>
      {children}
    </EmptyContent>
  );
}

export function Empty({ isProfile, user, view, hideCTA = true }) {
  const isOwnProfile = user?.isOwnProfile;
  const displayName = user?.displayName;
  const history = useHistory();

  const handleClick = () => {
    analytics.track("Profile - Empty State Button Click");
    history.push("/match-history");
  };

  if (!isProfile) {
    return (
      <EmptyContent display="box" py={[3]}>
        <ContentAnnouncement
          title={"No results found"}
          subtitle="It seems we can't find any results based on your search."
          svg=""
        />
      </EmptyContent>
    );
  }

  const EMPTY_CONTENT_MAP = {
    [EClipsViews.Following]: {
      title: isOwnProfile
        ? "No clips by creators that you follow"
        : `No clips by creators ${displayName} follows`,
      subtitle: isOwnProfile
        ? "Clips will appear here from Allstar members you follow"
        : `Clips will appear here from Allstar members ${displayName} follows`,
      svg: <ClipEmptyIcon />,
    },
    [EClipsViews.Clips]: {
      title: isOwnProfile
        ? "You have not made any clips yet"
        : `${displayName} has not made any clips yet`,
      subtitle: isOwnProfile
        ? "But with the magic of Allstar, you can start creating them right now! Head over to Match History to access your recent matches and get going."
        : `Clips will appear here once ${displayName} has made one`,
      svg: <ClipEmptyIcon />,
      button: (
        <StyledButton size="tiny" flex={true} onClick={() => handleClick()}>
          Create Clips
        </StyledButton>
      ),
    },
    [EClipsViews.Montages]: {
      title: isOwnProfile
        ? "You have not made any Montages"
        : `${displayName} has not made any Montages yet`,
      subtitle: isOwnProfile
        ? "Montages will appear here once you start making them"
        : `Montages will appear here once ${displayName} has made one`,
      svg: <ClipEmptyIcon />,
    },
    [EClipsViews.Mobile]: {
      title: isOwnProfile
        ? "You have not made any Mobile clips"
        : `${displayName} has not made any Mobile clips yet`,
      subtitle: isOwnProfile
        ? "Mobile clips will appear here once you start making them"
        : `Mobile clips will appear here once ${displayName} has made one`,
      svg: <ClipEmptyIcon />,
    },
  };

  return (
    <EmptyContainer>
      <ContentAnnouncement
        title={EMPTY_CONTENT_MAP[view].title}
        subtitle={EMPTY_CONTENT_MAP[view].subtitle}
        svg={EMPTY_CONTENT_MAP[view].svg}
        button={EMPTY_CONTENT_MAP[view].button}
        isOwnProfile={isOwnProfile}
      />
    </EmptyContainer>
  );
}

const EmptyContent = styled(FullWidthWrapper)`
  text-align: center;
`;

const ClipEmptyIcon = styled(ClipsEmpty)`
  height: 80px;
`;

const StyledButton = styled(Button)`
  margin-top: 20px;
  border-radius: 24px;
  padding: 0px 20px;
  height: 40px;
`;
